<template>
  <div class="loading balloon-message"
        :style="{
          'background': color.balloonOtr + '!important',
          'color': autoColor(color.balloonOtr),
          'filter': shadowStyle()}">
    <span v-for="(m, i) in '・・・'" :key="i">{{ m }}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import hex2rgb from '@/functions/hex2rgb'
export default {
  name: 'mogomogo',
  computed: {
    ...mapState('directtalk', ['color'])
  },
  methods: {
    autoColor (c) {
      var color = hex2rgb(c)
      var cl = '#000'
      if ((color[0] * 0.299 + color[1] * 0.587 + color[2] * 0.114) < 206) {
        cl = '#FFF'
      }
      return cl
    },
    shadowStyle () {
      if (this.color.shadowType === 0) return 'drop-shadow(0px 0px 0px rgba(0,0,0,0.2))'
      else return 'drop-shadow(1px 1px 1px rgba(0,0,0,0.2))'
    }
  }
}
</script>

<style scoped>
.balloon-message {
  width: 100px;
  height: 48px;
  background: aliceblue;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  margin-left: 50px;
  margin-bottom: 10px;
  border-radius: 8px;
  animation: SlideIn 0.5s;
  transform-origin: top;
}
@keyframes SlideIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.loading span {
  display: inline-block;
  margin: 0 -.05em;
  animation: loading .7s infinite;
}
.loading span:nth-child(2) {
  animation-delay: .1s;
}
.loading span:nth-child(3) {
  animation-delay: .2s;
}
@keyframes loading {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.8);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/MogoMogo.vue